import { __awaiter, __generator } from 'tslib';
import Vue from 'vue';
import { magic } from '@gig/magic-sdk';

var _a;
var STATIC_PAGES_NAMESPACE = 'STATIC_PAGES_NAMESPACE';
var SET_STATIC_PAGE = 'SET_STATIC_PAGE';
var SET_IS_LOADING = 'SET_IS_LOADING';
var SET_CATEGORY = 'SET_CATEGORY';
var getPageKey = function (slug, lang) { return lang + "---" + slug; };
var staticPageGetters = {
    staticPage: function (state) { return function (slug, lang) {
        return state.staticPages[getPageKey(slug, lang)];
    }; },
    getCategory: function (state) {
        return state.category;
    },
    isLoading: function (state) { return function (slug, lang) {
        return state.isLoading[getPageKey(slug, lang)];
    }; },
};
var staticPageActions = {
    fetchStaticPage: function (_a, _b) {
        var commit = _a.commit, state = _a.state;
        var slug = _b.slug, lang = _b.lang;
        return __awaiter(this, void 0, void 0, function () {
            var key, page;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        key = getPageKey(slug, lang);
                        if (state.staticPages[key] || state.isLoading[key]) {
                            return [2 /*return*/];
                        }
                        commit(SET_IS_LOADING, { isLoading: true, key: key });
                        return [4 /*yield*/, magic.methods.pages.get({ slug: slug, lang: lang })];
                    case 1:
                        page = _c.sent();
                        commit(SET_STATIC_PAGE, { page: page, key: key });
                        commit(SET_IS_LOADING, { isLoading: false, key: key });
                        return [2 /*return*/];
                }
            });
        });
    },
    fetchCategory: function (_a, _b) {
        var commit = _a.commit;
        var category = _b.category, lang = _b.lang;
        return __awaiter(this, void 0, void 0, function () {
            var fetchedCategory;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, magic.methods.pages.get({
                            category: category,
                            lang: lang,
                        })];
                    case 1:
                        fetchedCategory = _c.sent();
                        commit(SET_CATEGORY, fetchedCategory);
                        return [2 /*return*/, fetchedCategory];
                }
            });
        });
    },
};
var staticPage = {
    namespaced: true,
    state: {
        staticPages: {},
        isLoading: {},
        category: [],
    },
    getters: staticPageGetters,
    actions: staticPageActions,
    mutations: (_a = {},
        _a[SET_STATIC_PAGE] = function (state, _a) {
            var page = _a.page, key = _a.key;
            Vue.set(state.staticPages, key, page);
        },
        _a[SET_IS_LOADING] = function (state, _a) {
            var isLoading = _a.isLoading, key = _a.key;
            Vue.set(state.isLoading, key, isLoading);
        },
        _a[SET_CATEGORY] = function (state, fetchedCategory) {
            state.category = fetchedCategory;
        },
        _a),
};

export { SET_CATEGORY, SET_IS_LOADING, SET_STATIC_PAGE, STATIC_PAGES_NAMESPACE, staticPage, staticPageActions, staticPageGetters };
